<template>
	<div class="modal fade" id="modal-cadastro-unidade">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				
				<div class="modal-header">
					<h4 class="modal-title">Unidade</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>

				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<img :src="logotipo" style="width: 16%; margin-left: 42%;">
						</div>
					</div>

					<div class="row">
				        <div class="col-lg-6">
				            <div class="form-group">
				                <label>Nome</label>
				                <input type="text" class="form-control form-control-sm" :class="[(data.nome) ? '' : incomplete]" v-model="data.nome">
				            </div>
				        </div>

				        <div class="col-lg-6">
				             <div class="form-group">
				                <label>Telefone</label>
				                <input type="text" class="form-control form-control-sm" :class="[(data.telefone) ? '' : incomplete]" v-model.number="data.telefone" v-mask="['(##) ####-####', '(##) #####-####']">
				            </div>
				        </div>
				    </div>

				    <div class="row">
				    	<div class="col-lg-6">
					        <div class="form-group">
					           	<label>Endereço</label>
				                <input type="text" class="form-control form-control-sm" :class="[(data.logradouro) ? '' : incomplete]" v-model="data.logradouro">
					        </div>
				        </div>

				        <div class="col-lg-4">
				            <div class="form-group">
				                <label>Cidade</label>
				                <input type="text" class="form-control form-control-sm" :class="[(data.cidade) ? '' : incomplete]" v-model="data.cidade">
				            </div>
				        </div>

				    	<div class="col-lg-2">
				            <div class="form-group">
				                <label>Estado</label>
				                <select class="form-control form-control-sm" :class="[(data.estado) ? '' : incomplete]" v-model="data.estado">
				                	<option v-for="uf in uf_list" :value="uf.sigla">{{ uf.sigla }}</option>
				                </select>
				            </div>
				        </div>
				    </div>
				</div>

				<div class="modal-footer">
					<button class="btn btn-danger btn-sm"  v-if="action == 'view'" @click="deletar"  >Deletar</button>
					<button class="btn btn-warning btn-sm" v-if="action == 'view'" @click="atualizar">Atualizar</button>
					<button class="btn btn-success btn-sm" v-if="action == 'add'"  @click="adicionar">Inserir</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api   from "@/mixins/api.js"
	import alert from "@/components/Tools/alert.vue"

	export default {
		name: "modal-unidade",
		props: [ 'data', 'action' ],
		mixins: [api],

		data: () => { return {
			incomplete: false,
			uf_list: null
		}},

		created() {
			this.get_UF()
		},

		computed: {
			logotipo() { return this.$store.state.config.logotipo }
		},

		methods: {
			async get_UF() {
				this.uf_list = await fetch("https://servicodados.ibge.gov.br/api/v1/localidades/estados").then( r => r.json() )
			},

			async adicionar() {
				//
				//	Verifica se todos os dados foram preenchidos
				//
				if ( !this.data.nome || !this.data.telefone || !this.data.logradouro || !this.data.cidade || !this.data.estado ) 
				{
					window.alert("Preencha os campos obrigatórios!")
					this.incomplete = "focus"
				}

				else 
				{
					const response = await this.POST("Unidade", this.data)
					
					if ( response.status == "success") this.$emit("alert", { status: "success", result: "Unidade adicionada com sucesso."} )
					else window.alert(response.result)
				}
			},

			async atualizar() {
				//
				//	Verifica se todos os dados foram preenchidos
				//
				if ( !this.data.nome || !this.data.telefone || !this.data.logradouro || !this.data.cidade || !this.data.estado ) 
				{
					window.alert("Preencha os campos obrigatórios!")
					this.incomplete = "focus"
				}

				else 
				{
					const response = await this.PUT("Unidade", this.data)
					
					if ( response.status == "success") this.$emit("alert", { status: "success", result: "Unidade atualizada com sucesso com sucesso."} )
					else window.alert(response.result)
				}
			},

			async deletar() {
				if ( window.confirm(`Isso irá deletar a unidade ${this.data.nome} permanentemente.`) ) {
					const response = await this.DELETE('Unidade', this.data.id)
					if ( response.status == "success") this.$emit("alert", response )
					else window.alert(response.result)
				}
			}
		}
	}
</script>

<style scoped>
</style>
